import React, { useEffect, useState, useRef } from "react";
import { apiurl, organizer_url, getSupportbagecolor, get_date_time, onlyDayMonth, shortPer, laravel_asset } from '../../common/Helpers';
import { Col, Row } from "react-bootstrap";
import arrow from "../../assets/arrow.svg";
import JoditEditor from 'jodit-react';
import Card from 'react-bootstrap/Card';
import { Link, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2'
import Select from 'react-select'
import toast, { ToastBar, Toaster } from "react-hot-toast";
import withReactContent from 'sweetalert2-react-content'
import Noimg from "../../common/image/noimg.jpg";
import Nouserphoto from '../../common/image/nouser.png';
import calendar from "../../assets/calendar.svg";
import locationIcon from "../../assets/location (5) 1.svg";
import { FaUpload } from "react-icons/fa6";
import { FiCopy } from "react-icons/fi";

// component
const Dashboard = () => {
    const navigate = useNavigate();
    const MySwal = withReactContent(Swal)
    const organizerid = localStorage.getItem('organizerid');
    // Loader
    const [Loader, setLoader] = useState(false);
    const [CustomerLoader, setCustomerLoader] = useState(false);
    const [Apiloader, setApiloader] = useState(false);
    const [SendmailLoader, setSendmailLoader] = useState(false);
    const [ALlCustomerLoader, setALlCustomerLoader] = useState(false);
    const [isAllcustomer, setisAllcustomer] = useState(false);
    const [Attacmentloader, setAttacmentloader] = useState(false);
    const [uploadedImages, setUploadedImages] = useState([]);
    const imageInputRef = useRef(null);

    // states
    const [EventList, setEventList] = useState([]);
    const [EventListOption, setEventListOption] = useState([]);
    const [EventPreListOption, setEventPreListOption] = useState([]);
    const [AttendanceListOption, setAttendanceListOption] = useState([]);
    const [OrganizersOption, setOrganizersOption] = useState([]);
    const [NewsletterOption, setNewsletterOption] = useState([]);
    const [SelectedNewsletter, setSelectedNewsletter] = useState([]);
    const [SelectedOrg, setSelectedOrg] = useState([]);
    const [AttendanceSelected, setAttendanceSelected] = useState([]);
    const [Membershiplist, setMembershiplist] = useState([]);
    const [selectedMemberplan, setselectedMemberplan] = useState([]);
    const [Eventselected, setEventselected] = useState();
    const [EventPreselected, setEventPreselected] = useState();
    const [ticketOptions, setTicketOptions] = useState([]);
    const [Ticketselected, setTicketselected] = useState();
    const [Customerselected, setCustomerselected] = useState();
    const [EventData, setEventData] = useState();
    const [Messge, setMessge] = useState();
    const editor = useRef(null);
    const [content, setContent] = useState('');
    const [Selectedtype, setSelectedtype] = useState();
    const EventOption = [
        {
            options: EventListOption
        }
    ]
    const EventPreOption = [
        {
            options: EventListOption
            // EventPreListOption
        }
    ]
    const AttendanceOption = [
        {
            options: AttendanceListOption
        }
    ]
    const Customerbyorg = [
        {
            options: OrganizersOption
        }
    ]
    const selectMemebership = (id) => {
        if (selectedMemberplan.includes(id)) {
            setselectedMemberplan(selectedMemberplan.filter((categoryId) => categoryId !== id));
        } else {
            setselectedMemberplan([...selectedMemberplan, id]);
        }
    }
    const HandelSelectPreEvents = (selectedOptions) => {
        if (selectedOptions.some(option => option.value === 'selectAll')) {
            setEventPreselected(EventListOption.slice(1));
        } else {
            setEventPreselected(selectedOptions);
        }
    };
    const HandelSelectTicketType = (selectedOptions) => {
        if (selectedOptions.some(option => option.value === 'selectAll')) {
            setTicketselected(ticketOptions.slice(1));
        } else {
            setTicketselected(selectedOptions);
        }
    };
    const HandelOrgSelect = (selectedOptions) => {
        if (selectedOptions.some(option => option.value === 'selectAll')) {
            setSelectedOrg(OrganizersOption.slice(1));
        } else {
            setSelectedOrg(selectedOptions);
        }
    };
    const HandelNewsletterSelect = (selectedOptions) => {
        if (selectedOptions.some(option => option.value === 'selectAll')) {
            setSelectedNewsletter(NewsletterOption.slice(1));
        } else {
            setSelectedNewsletter(selectedOptions);
        }
    };
    useEffect(() => {
        if (Eventselected) {
            getEventData(Eventselected.value);
        }
    }, [Eventselected]);
    const handleEventChange = () => {
        const newTicketOptions = [];
        if (EventPreselected) {
            newTicketOptions.push({ value: 'selectAll', label: 'Select All' });
            EventPreselected.forEach(selectedEvent => {
                const selectedEventData = EventList.find(event => event._id === selectedEvent.value);
                if (selectedEventData && selectedEventData.allprice) {
                    const filteredTicketOptions = selectedEventData.allprice
                        .filter(ticket => ticket.isdelete === 0)
                        .map(ticket => ({ value: ticket.id, label: ticket.name }));

                    // Add 'Select All' option at the beginning
                    // Append the filtered ticket options
                    newTicketOptions.push(...filteredTicketOptions);
                }

            });
        }
        setTicketOptions(newTicketOptions);
    };
    const fetchNewsletterList = async () => {
        try {

            fetch(apiurl + 'admin/newsletterlist', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json', // Set the Content-Type header to JSON
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success == true) {
                        const orglistOptions = [
                            { value: 'selectAll', label: 'Select All' },
                            ...data.data.map(customer => ({
                                value: customer.email,
                                label: customer.email
                            }))
                        ];
                        //                         setNewsletterOption
                        // setSelectedNewsletter
                        setNewsletterOption(orglistOptions);
                    }

                })
                .catch(error => {
                    console.error('Insert error:', error);

                });
        } catch (error) {
            console.error('Api error:', error);

        }

    }
    const getMembershiip = async () => {
        try {
            fetch(apiurl + 'admin/package-plan-list', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json', // Set the Content-Type header to JSON
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success == true) {
                        setMembershiplist(data.data);
                    }
                })
                .catch(error => {
                    console.error('Insert error:', error);
                });
        } catch (error) {
            console.error('Api error:', error);
        }

    }
    const getOrganizerlist = async () => {
        try {
            const requestData = {
                isactive: 1,
            };
            fetch(apiurl + 'admin/get-organizer-list', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json', // Set the Content-Type header to JSON
                },
                body: JSON.stringify(requestData),
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success == true) {
                        const orglistOptions = [
                            { value: 'selectAll', label: 'Select All' },
                            ...data.data.map(customer => ({
                                value: customer._id,
                                label: customer.name
                            }))
                        ];
                        setOrganizersOption(orglistOptions);
                    }
                })
                .catch(error => {
                    console.error('Insert error:', error);
                });
        } catch (error) {
            console.error('Api error:', error);
        }

    }

    const getMyEvents = async () => {
        try {
            setLoader(true)
            const requestData = {
                
            };
            fetch(apiurl + 'event/list', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json', // Set the Content-Type header to JSON
                },
                body: JSON.stringify(requestData),
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success == true) {
                        setEventList(data.data);

                        const today = new Date().toISOString().slice(0, 10).replace(/-/g, '');
                        const upcomingEvents = data.data.filter(event => event.end_mindate >= today);
                        const pastEvents = data.data.filter(event => event.end_mindate < today);
                        const upcomingOptions = [
                            ...upcomingEvents.map(customer => ({
                                value: customer._id,
                                label: customer.display_name
                            }))
                        ];
                        const pastOptions = [
                            { value: 'selectAll', label: 'Select All' },
                            ...pastEvents.map(customer => ({
                                value: customer._id,
                                label: customer.display_name
                            }))
                        ];

                        setEventListOption(upcomingOptions);
                        setEventPreListOption(pastOptions);
                    }
                    setLoader(false)
                })
                .catch(error => {
                    console.error('Insert error:', error);
                    setLoader(false)
                });
        } catch (error) {
            console.error('Api error:', error);
            setLoader(false)
        }
    }
    const getEventData = async (id) => {
        try {
            setApiloader(true)
            const requestData = {
                id: id
            };
            fetch(apiurl + 'event/view-event-details', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json', // Set the Content-Type header to JSON
                },
                body: JSON.stringify(requestData),
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success == true) {
                        setEventData(data.data);
                    } else {
                        Toaster.error(data.message);
                    }
                    setApiloader(false);
                })
                .catch(error => {
                    console.error('Insert error:', error);
                    setApiloader(false);
                });
        } catch (error) {
            console.error('Api error:', error);
            setApiloader(false);
        }
    }


    // const [counter, setCounter] = useState(0);
    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setCounter((prevCounter) => prevCounter + 1); // Increment the counter to trigger a re-render
    //     }, 3000); // 3000 milliseconds = 3 seconds

    //     return () => clearInterval(interval); // Clear the interval when the component unmounts
    // }, []);

    // useEffect(() => {
    //     handelSender("text");
    // }, [counter]);
    
    const handelSendmail = async () => {
        try {
            if (Selectedtype && Selectedtype.value == 2 && !Eventselected) {
                return toast.error("No event selected");
            }

            if (selectedMemberplan.length < 1 && SelectedOrg.length < 1 && SelectedNewsletter.length < 1) {
                return toast.error("No user selected");
            }
            setSendmailLoader(true);
            const requestData = {
                membershipid: selectedMemberplan,
                organizersid: SelectedOrg,
                newsletter: SelectedNewsletter,
                message: content,
                usertype: "Admin",
                eventid: Eventselected && Eventselected.value ? Eventselected.value : null,
            };
            fetch(apiurl + 'event/admin-eventmail-send', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json', // Set the Content-Type header to JSON
                },
                body: JSON.stringify(requestData),
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success == true) {
                        toast.success(data.message);
                        var eventID = Eventselected && Eventselected.value ? Eventselected.value : 'text';
                        emptyfield();
                        handelSender(eventID);
                    } else {
                        toast.error(data.message);
                    }
                    setSendmailLoader(false)
                })
                .catch(error => {
                    console.error('Insert error:', error);
                    setSendmailLoader(false)
                });
        } catch (error) {
            console.error('Api error:', error);
            setSendmailLoader(false)
        }
    }
    const handelSender = async (id) => {
        try {
            const requestData = {
                orgid: organizerid,
                eventid: id,
            };
            fetch(apiurl + 'event/eventmail-sender', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json', // Set the Content-Type header to JSON
                },
                body: JSON.stringify(requestData),
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success == true) {

                    } else {

                    }

                })
                .catch(error => {
                    console.error('Insert error:', error);

                });
        } catch (error) {
            console.error('Api error:', error);

        }
    }

    const emptyfield = () => {
        setContent('');
        setAttendanceSelected("");
        setEventselected("");
        setEventPreselected("");
        setTicketselected("");
        setEventData("");
        setMessge("");
        setisAllcustomer(false);
        setselectedMemberplan([]);
        setSelectedOrg([]);
    }
    const removeAllcustomer = () => {
        setAttendanceSelected("");
        setAttendanceListOption([]);
        setisAllcustomer(false);
    }

    useEffect(() => {
        getMyEvents();
        getMembershiip();
        getOrganizerlist();
        fetchNewsletterList();
    }, []);
    useEffect(() => {
        handleEventChange();
        setTicketselected("");
    }, [EventPreselected]);
    useEffect(() => {
        setAttendanceSelected("");
    }, [Ticketselected]);
    const uploadBannerToServer = async (imageFile) => {
        console.log(imageFile);
        const formData = new FormData();
        formData.append('image', imageFile); // 'image' is the parameter name expected by your API

        try {
            setAttacmentloader(true);
            const response = await fetch('https://tixme.co/tixme_storage/api/upload-image', {
                method: 'POST',
                body: formData, // No headers needed, as FormData sets the Content-Type to multipart/form-data
            });
            if (!response.ok) {
                toast.error('File not uploaded try again');
                setAttacmentloader(false);

                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const result = await response.json();
            if (result) {
                // result.image_name
                setAttacmentloader(false);

                console.log(result.image_name);
                setUploadedImages((prevImages) => [...prevImages, { url: result.image_name, name: imageFile.name }]);
            } else {
                setAttacmentloader(false);

                return toast.error('File not uploaded try again');
            }
            // Handle the response here (e.g., showing a success message, updating UI)
        } catch (error) {
            setAttacmentloader(false);

            toast.error('File not uploaded try again');
        }
    }
    const handleBannerImageChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            let img = e.target.files[0];
            uploadBannerToServer(e.target.files[0]).then(() => {
                // Reset the input value after the image is uploaded
                if (imageInputRef.current) {
                    imageInputRef.current.value = "";
                }
            });
        }
    };


    return (
        <>
            <div className="content-body" style={{ background: '#F1F1F1' }}>
                <div className="container-fluid">
                    <Row className="justify-content-center">
                        <div className="col-md-12">
                            <Card className="py-4">
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <Card>
                                                <Card.Body>
                                                    <Card.Title className="border-bottom pb-2">Mail</Card.Title>
                                                    <Card.Text>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="form-group">
                                                                    <p>Select Type</p>
                                                                    <Select
                                                                        isClearable={false}
                                                                        options={[
                                                                            { value: 1, label: "Normal Text" },
                                                                            { value: 2, label: "Event Reminder" },
                                                                        ]}
                                                                        className='react-select'
                                                                        classNamePrefix='select'
                                                                        onChange={setSelectedtype}
                                                                        value={Selectedtype}
                                                                    />
                                                                </div>
                                                            </div>
                                                            {Selectedtype && Selectedtype.value == 2 && (
                                                                <div className="col-md-12">
                                                                    <div className="form-group">
                                                                        <p>Select Your Event</p>
                                                                        <Select
                                                                            isClearable={false}
                                                                            options={EventOption}
                                                                            className='react-select'
                                                                            classNamePrefix='select'
                                                                            onChange={setEventselected}
                                                                            value={Eventselected}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {Apiloader ? (
                                                                <div className="linear-background w-100" style={{ height: '250px' }}> </div>
                                                            ) : (
                                                                <>
                                                                    {EventData && (
                                                                        <div className="col-md-12">
                                                                            <div className="row d-flex justify-content-center">
                                                                                <div className="col-md-12 col-12 col-lg-12 col-xl-8">
                                                                                    <div className="home-events-box">
                                                                                        <div className="bg-white rounded-10 shadow-bottom pb-3 cursor-pointer overflow-hidden" style={{ height: '100%', position: 'relative' }}>
                                                                                            <div style={{ position: 'relative' }}>
                                                                                                <span className="event-category-img">{EventData.category_name}</span>
                                                                                                <img className="event-card-img" src={EventData.thum_image ? EventData.thum_image : Noimg} alt="" />
                                                                                                <div className="d-flex align-items-center event-date-small-box">
                                                                                                    <span className="event-date-small  d-flex align-items-center">
                                                                                                        <img className="card-icon me-2" src={calendar} alt="" />
                                                                                                        <span className="text-primary-color fw-bold me-0 mb-0 mt-md-0">
                                                                                                            {onlyDayMonth(EventData.start_date)}
                                                                                                        </span>
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="row px-2 mt-2">
                                                                                                <div className="col-md-7 d-flex align-items-center col-7">
                                                                                                    <img className="card-icon-logo me-2" src={EventData.organizer_logo ? EventData.organizer_logo : Nouserphoto} alt="" />
                                                                                                    <div className="d-flex flex-column align-items-start justify-content-start">
                                                                                                        <small className="mb-0" style={{ fontSize: '12px' }}>Originated by</small>
                                                                                                        <p className="text-primary-color fw-bold mb-0 mt-n1 event-text-org-name">
                                                                                                            {EventData.organizer_name}
                                                                                                        </p>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="col-md-5  col-5">
                                                                                                    <div className="bg-fade rounded text-center event-cart-price-box">
                                                                                                        <span className="text-primary-color fw-bold event-cart-display-price">{EventData.isfreeticket == 1 ? 'FREE' : EventData.countrysymbol + EventData.displayprice + '.00'}</span>
                                                                                                        <p className="small fw-bold mb-0 pb-0">Onwards</p>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="row mt-1">
                                                                                                <div className="col-md-12">
                                                                                                    <div className="d-flex align-items-center justify-content-start my-2 mx-2">
                                                                                                        <img className="card-icon me-1" src={locationIcon} alt="" />
                                                                                                        <p className="text-primary-color fw-bold mb-0 event-cart-location">
                                                                                                            {EventData.city ? EventData.city + ',' : ''} {EventData.countryname ? EventData.countryname : ''}
                                                                                                        </p>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="desc-h ms-3 fw-bold mb-0">{shortPer(EventData.display_name, 30)}</div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </>
                                                            )}

                                                            <div className="col-md-12">
                                                                <h4>Body</h4>
                                                                {/* <textarea class="form-control" onChange={(e) => setMessge(e.target.value)} id="exampleFormControlTextarea1" rows="9" placeholder="Enter your message" value={Messge}>{Messge}</textarea> */}
                                                                <JoditEditor
                                                                    ref={editor}
                                                                    value={content}
                                                                    config={{
                                                                        readonly: false,
                                                                        placeholder: 'Start typing...',
                                                                        // uploader: {
                                                                        //     insertImageAsBase64URI: false,
                                                                        //     imagesExtensions: ["jpg", "png", "jpeg", "gif"],
                                                                        //     url: 'https://tixme.co/tixme_storage/api/mailimage',
                                                                        //     format: 'json',
                                                                        //     method: 'POST',
                                                                        //     headers: {}, // If you need to set any headers for the request
                                                                        //     data: {}, // If you need to send any additional data with the request
                                                                        //     prepareData: (formData) => {
                                                                        //         // Modify the FormData object if needed before sending it to the server
                                                                        //         return formData;
                                                                        //     },
                                                                        //     isSuccess: (resp) => {
                                                                        //         // Define how to determine if the upload was successful based on the server response
                                                                        //         return resp.success;
                                                                        //     },
                                                                        //     process: (resp) => {
                                                                        //         // Define how to process the server response to get the image URL
                                                                        //         return {
                                                                        //             files: [{ baseurl: '', name: resp.image_name, url: resp.image_url }],
                                                                        //             path: '',
                                                                        //             baseurl: '', // The base URL for the images, if needed
                                                                        //             error: resp.error || '',
                                                                        //             msg: resp.msg || ''
                                                                        //         };
                                                                        //     },
                                                                        //     defaultHandlerSuccess: function (data, resp) {
                                                                        //         // Define what to do after a successful upload
                                                                        //         var i, field = this.options.uploader.filesVariableName;
                                                                        //         if (data[field] && data[field].length) {
                                                                        //             for (i = 0; i < data[field].length; i += 1) {
                                                                        //                 this.selection.insertImage(data.baseurl + data[field][i]);
                                                                        //             }
                                                                        //         }
                                                                        //     },
                                                                        //     error: function (e) {
                                                                        //         // Define what to do in case of an error
                                                                        //         this.events.fire('errorMessage', [e.getMessage(), 'error', 4000]);
                                                                        //     }
                                                                        // },
                                                                    }}
                                                                    tabIndex={1}
                                                                    onBlur={newContent => setContent(newContent)}
                                                                    onChange={newContent => { }}
                                                                />

                                                            </div>
                                                            <div className="col-md-12 my-2 d-flex justify-content-end">
                                                                <button onClick={() => document.getElementById('imageInputbanner').click()} type="button" className="btn btn-light"> <FaUpload /> {Attacmentloader ? 'Uploading...' : 'Attachment'}</button>
                                                                <input
                                                                    type="file"
                                                                    id="imageInputbanner"
                                                                    accept="image/*"
                                                                    onChange={handleBannerImageChange}
                                                                    style={{ display: 'none' }}
                                                                    ref={imageInputRef}
                                                                />
                                                            </div>
                                                            <div className="col-md-12">
                                                                {uploadedImages.map((item, index) => (
                                                                    <div key={index} className="row mb-2">
                                                                        <div className="col-md-9">
                                                                            <p className="mb-0" style={{ fontSize: '14px' }}>{item.name}</p>
                                                                        </div>
                                                                        <div className="col-md-3">
                                                                            <button
                                                                                className="btn btn-primary"
                                                                                onClick={() => { navigator.clipboard.writeText(laravel_asset + item.url); toast.success("Copied") }}
                                                                            >
                                                                                <FiCopy /> URL
                                                                            </button>
                                                                        </div>
                                                                        <div className="col-md-12">
                                                                            <hr className="my-1"></hr>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </Card.Text>
                                                </Card.Body>
                                            </Card>
                                        </div>
                                        <div className="col-md-6">
                                            <Card>
                                                <Card.Body>
                                                    <Card.Title className="border-bottom pb-2">Attendance</Card.Title>
                                                    <Card.Text>
                                                        <div className="row">
                                                            {Membershiplist.length > 0 && (
                                                                <>
                                                                    <div className="col-12 col-md-12">
                                                                        Select Membership Attendance
                                                                    </div>
                                                                    {Membershiplist.map((item) => (
                                                                        <div className="col-12 col-md-4">
                                                                            <button onClick={() => selectMemebership(item._id)} type="button" class={`btn ${selectedMemberplan.includes(item._id) ? 'theme-bg text-white' : 'btn-outline-secondary'} text-capitalize w-100`}>{item.name}</button>
                                                                        </div>
                                                                    ))}
                                                                </>
                                                            )}
                                                            <div className="col-12 mt-3">
                                                                <div className="form-group">
                                                                    <p>Select Attendance By Organizers</p>
                                                                    <Select
                                                                        isClearable={false}
                                                                        options={Customerbyorg}
                                                                        isMulti
                                                                        className='react-select'
                                                                        classNamePrefix='select'
                                                                        onChange={HandelOrgSelect}
                                                                        value={SelectedOrg}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-12 mt-3">
                                                                <div className="form-group">
                                                                    <p>Select Newsletter Users</p>
                                                                    <Select
                                                                        isClearable={false}
                                                                        options={NewsletterOption}
                                                                        isMulti
                                                                        className='react-select'
                                                                        classNamePrefix='select'
                                                                        onChange={HandelNewsletterSelect}
                                                                        value={SelectedNewsletter}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div className="row">
                                                                {SendmailLoader ? (
                                                                    <div className="col-md-12 col-xl-6">
                                                                        <button type="button" className="GetLatestUpdateButton">
                                                                            <div className="left px-0 px-md-4">
                                                                                <small className="ms-2">Please Wait...</small>
                                                                            </div>
                                                                            <div className="right">
                                                                                <img style={{ width: "18px" }} src={arrow} alt="" />
                                                                            </div>
                                                                        </button>
                                                                    </div>
                                                                ) : (
                                                                    <>
                                                                        <div className="col-md-12 col-xl-6">
                                                                            <button type="button" className="GetLatestUpdateButton" onClick={() => handelSendmail()}>
                                                                                <div className="left px-0 px-md-4">
                                                                                    <small className="ms-2">Send Mail</small>
                                                                                </div>
                                                                                <div className="right">
                                                                                    <img style={{ width: "18px" }} src={arrow} alt="" />
                                                                                </div>
                                                                            </button>
                                                                        </div>
                                                                        {/* <div className="col-md-12  col-xl-6">
                                                                                    <button type="button" className="GetLatestUpdateButton">
                                                                                        <div className="left px-0 px-md-4">
                                                                                            <small className="ms-2">Schedule Mail</small>
                                                                                        </div>
                                                                                        <div className="right">
                                                                                            <img style={{ width: "18px" }} src={arrow} alt="" />
                                                                                        </div>
                                                                                    </button>
                                                                                </div> */}
                                                                    </>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </Card.Text>
                                                </Card.Body>
                                            </Card>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card >
                        </div >
                    </Row >
                </div >
            </div >

        </>
    )
}
export default Dashboard;